import React from 'react';
import { Text, StyleSheet} from '@react-pdf/renderer';

export default () =>(
    <Text style={{fontFamily: 'subHeading'}}>&</Text>
)
